import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  withCredentials: true, // если используете куки (для сессий)
});

// Интерсептор запроса — добавляем токен в заголовок
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Интерсептор ответа — обрабатываем 401 (неавторизован)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Если сервер вернул 401 — токен просрочен или невалиден
      localStorage.removeItem("token");
      // Можно перенаправить на логин (но осторожно, чтобы не зациклиться)
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
